import useMerchantPortalAxios from "../utils/axios";
import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  setFlag,
  setIsPopup,
  setLoading,
  setResponseDescription,
  setResponseTitle,
} from "../features/responseSlice";
import {
  setCashInDataNewreq,
  setCashOutDataNewOrder,
  showCancelResult,
  setCashOutFeesResponse,
  setCashInFeesResponse,
  setDeliveryConfig,
} from "../features/CashInAndOutSlice";

const useCashOutApi = () => {
  const [cashoutOrders, setCashoutOrders] = useState([]);
  const [ordersLoading, setOrdersLoading] = useState(false);
  const [totalNbOfPage, setTotalNbOfPage] = useState(1);
  const [totalCount, setTotalCount] = useState(1);

  const MerchantPortalAxios = useMerchantPortalAxios();
  const dispatch = useDispatch();

  const GetCashoutOrders = async (method, pageNb, dateFrom, dateTo, type) => {
    const objKey =
      method === "Cash Out" ? "CashoutOrders" : "CashDepositOrders";
    setOrdersLoading(true);
    const url =
      method === "Cash Out"
        ? `/v1/Cashout/GetCashoutOrders`
        : `/v1/CashDeposit/GetCashDepositOrders`;
    await MerchantPortalAxios.post(url, {
      SessionID: sessionStorage.getItem("SessionID"),
      page: pageNb,
      pageSize: 10,
      DateFrom: dateFrom,
      DateTo: dateTo,
      OrderType: type,
    }).then((res) => {
      const orders = res?.data?.Payload?.[objKey] ?? [];
      setCashoutOrders(orders);
      if (orders.length === 0) {
        setTotalNbOfPage(0);
        setTotalCount(0);
      } else {
        setTotalNbOfPage(orders[0]?.TotalPages ?? 0); // ← no crash if null
        setTotalCount(orders[0]?.TotalCount ?? 0);
      }

      setOrdersLoading(false);
    });
  };

  const NewCashoutOrder = async (payload) => {
    const res = await MerchantPortalAxios.post(
      `/v1/Cashout/NewCashoutOrder`,
      payload,
    );
    return res.data?.Payload;
  };

  const NewCashDepositRequest = async (payload) => {
    const res = await MerchantPortalAxios.post(
      `/v1/CashDeposit/NewCashDepositRequest`,
      payload,
    );

    return res.data?.Payload;
  };

  const CancelCashDepositOrders = async (TransactionId) => {
    if (!TransactionId) return;
    const res = await MerchantPortalAxios.post(
      `/v1/CashDeposit/CancelCashDepositOrders`,
      {
        SessionID: sessionStorage.getItem("SessionID"),
        TransactionId: TransactionId,
      },
    )
      .then((res) => {
        dispatch(setFlag(1));
        dispatch(setIsPopup(true));
        dispatch(
          setResponseTitle(res.data?.Payload?.Title || "Deposit Cancelled"),
        );
        dispatch(
          setResponseDescription(
            res.data?.Payload?.Message ||
              "Your request has been successfully cancelled.",
          ),
        );
      })
      .catch((error) => {
        if (error?.response?.data?.isPopup) {
          if (error.response.data.PopupTitle === "LoaderError") {
            return;
          }
          dispatch(setFlag(10));
          dispatch(setLoading("idle"));
          dispatch(setIsPopup(true));
          dispatch(setResponseTitle(error.response.data.PopupTitle || "Error"));
          dispatch(
            setResponseDescription(
              error.response.data.PopupDescription ||
                "Could not cancel the order.",
            ),
          );
        } else {
          dispatch(setLoading("pending"));
        }
      });
  };

  const CancelCashOutOrders = async (TransactionId) => {
    if (!TransactionId) return;
    const res = await MerchantPortalAxios.post(
      `/v1/Cashout/CancelCashOutOrders`,
      {
        SessionID: sessionStorage.getItem("SessionID"),
        TransactionId: TransactionId,
      },
    )
      .then((res) => {
        dispatch(setFlag(1));
        dispatch(setIsPopup(true));
        dispatch(setResponseTitle(res.data?.Payload?.Title));
        dispatch(setResponseDescription(res.data?.Payload?.Message));
      })
      .catch((error) => {
        if (error?.response?.data?.isPopup) {
          if (error.response.data.PopupTitle === "LoaderError") {
            return;
          }
          dispatch(setFlag(10));
          dispatch(setLoading("idle"));
          dispatch(setIsPopup(true));
          dispatch(setResponseTitle(error.response.data.PopupTitle));
          dispatch(
            setResponseDescription(error.response.data.PopupDescription),
          );
        } else {
          dispatch(setLoading("pending"));
        }
      });
  };

  const GetCashoutProcessType = async (currency, amount) => {
    const res = await MerchantPortalAxios.post(
      "/v1/Cashout/GetCashoutProcessType",
      {
        SessionID: sessionStorage.getItem("SessionID"),
        CurrencyID: currency,
        Amount: amount,
      },
    );
    return res;
  };

  const GetCashDepositOptions = async () => {
    try {
      const res = await MerchantPortalAxios.post(
        "/v1/CashDeposit/GetCashDepositOptions",
        {
          SessionID: sessionStorage.getItem("SessionID"),
        },
      );
      dispatch(setCashInDataNewreq(res.data.Payload));
      return res.data.Payload;
    } catch (error) {
      throw error;
    }
  };

  const GetCashOutOptions = async () => {
    try {
      const res = await MerchantPortalAxios.post(
        "/v1/Cashout/GetCashOutOptions",
        {
          SessionID: sessionStorage.getItem("SessionID"),
        },
      );

      dispatch(setCashOutDataNewOrder(res.data.Payload));
      return res.data.Payload;
    } catch (error) {
      throw error;
    }
  };

  const SendSmsCode = async (MobileNo, Code) => {
    try {
      const res = await MerchantPortalAxios.post(
        "/v1/CashDeposit/SendSmsCode",
        {
          SessionID: sessionStorage.getItem("SessionID"),
          MobileNo,
          Code,
        },
      );

      const { Title, Message, flagCode } = res.data.Payload;

      if (flagCode === 0) {
        // ── success
        dispatch(
          showCancelResult({
            result: "success",
            resultTitle: Title,
            resultMessage: Message,
          }),
        );
      } else {
        // ── error — any non-zero flagCode
        dispatch(
          showCancelResult({
            result: "error",
            resultTitle: Title || "Something went wrong",
            resultMessage: Message || "Please try again later.",
          }),
        );
      }

      return res.data.Payload;
    } catch (error) {
      // ── network / server error
      dispatch(
        showCancelResult({
          result: "error",
          resultTitle: "Request Failed",
          resultMessage: "Unable to send SMS. Please try again.",
        }),
      );
      throw error;
    }
  };

  const GetCashDepositFees = async (CurrencyID, Amount) => {
    try {
      const res = await MerchantPortalAxios.post(
        "/v1/CashDeposit/GetCashDepositFees",
        {
          SessionID: sessionStorage.getItem("SessionID"),
          CurrencyID,
          Amount,
        },
      );
      const payload = res.data?.Payload;
      dispatch(setCashInFeesResponse(payload));
      return true;
    } catch (error) {
      dispatch(setCashInFeesResponse(null));
      const errorData = error?.response?.data;
      let dynamicMessage = "Unable to process request. Please try again.";
      if (errorData?.errors) {
        const errorMessages = Object.values(errorData.errors).flat();
        if (errorMessages.length > 0) {
          dynamicMessage = errorMessages[0];
        }
      } else if (errorData?.title) {
        dynamicMessage = errorData.title;
      }

      dispatch(
        showCancelResult({
          result: "error",
          resultTitle: errorData?.title || "Request Failed",
          resultMessage: dynamicMessage,
        }),
      );
      return false;
    }
  };

  const GetCashOutFees = async (CurrencyID, Amount) => {
    try {
      const res = await MerchantPortalAxios.post("/v1/Cashout/GetCashOutFees", {
        SessionID: sessionStorage.getItem("SessionID"),
        CurrencyID,
        Amount,
      });
      const payload = res.data?.Payload;
      dispatch(setCashOutFeesResponse(payload));
      return true;
    } catch (error) {
      dispatch(setCashOutFeesResponse(null));
      const errorData = error?.response?.data;
      let dynamicMessage = "Unable to process request. Please try again.";
      if (errorData?.errors) {
        const errorMessages = Object.values(errorData.errors).flat();
        if (errorMessages.length > 0) {
          dynamicMessage = errorMessages[0];
        }
      } else if (errorData?.title) {
        dynamicMessage = errorData.title;
      }
      dispatch(
        showCancelResult({
          result: "error",
          resultTitle: errorData?.title || "Request Failed",
          resultMessage: dynamicMessage,
        }),
      );
      return false;
    }
  };

  const GetDeliveryConfig = async (date) => {
    try {
      const res = await MerchantPortalAxios.post(
        "/v1/CashButler/GetDeliveryConfig",
        {
          SessionID: sessionStorage.getItem("SessionID"),
          date,
        },
      );
      const payload = res.data?.Payload;
      dispatch(setDeliveryConfig(payload));
      return true;
    } catch (error) {
      dispatch(setCashOutFeesResponse(null));
      const errorData = error?.response?.data;
      let dynamicMessage = "Unable to process request. Please try again.";
      if (errorData?.errors) {
        const errorMessages = Object.values(errorData.errors).flat();
        if (errorMessages.length > 0) {
          dynamicMessage = errorMessages[0];
        }
      } else if (errorData?.title) {
        dynamicMessage = errorData.title;
      }
      dispatch(
        showCancelResult({
          result: "error",
          resultTitle: errorData?.title || "Request Failed",
          resultMessage: dynamicMessage,
        }),
      );
      return false;
    }
  };

  return {
    GetDeliveryConfig,
    GetCashoutOrders,
    cashoutOrders,
    ordersLoading,
    totalNbOfPage,
    totalCount,
    NewCashoutOrder,
    NewCashDepositRequest,
    CancelCashDepositOrders,
    GetCashoutProcessType,
    GetCashOutOptions,
    GetCashDepositOptions,
    SendSmsCode,
    CancelCashOutOrders,
    GetCashOutFees,
    GetCashDepositFees,
  };
};

export default useCashOutApi;
